import { useEffect, useState } from "react";
import { commonActions } from "store/common";
import store from "store";
import type { PriceInfo, PriceUpdatePayload } from "../types/price-info";
import { fetch4BundlePriceTwsetListApi, update4BundlePriceTwsetApi } from "../api/settingApi";
import { getCsvDownloadApi } from "../../mst_csv/api/csvApi";

const use4BundlePriceTwset = () => {
  const [prices, setPrices] = useState<PriceInfo[]>([]);
  const [hasMore, setHasMore] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [query, setQuery] = useState({
    brand_cd: "",
    item_cd: "",
    limit: 50,
    offset: 1,
    honbu_flag: 1,
    store_flag: 1,
  });
  const [tempQuery, setTempQuery] = useState({
    brand_cd: "",
    item_cd: "",
    honbu_flag: 1,
    store_flag: 1,
    offset: 1,
  });
  const [csvDownload, setCsvDownload] = useState<{
    mst_4bundle_price_twset_latest_date?: string;
    mst_4bundle_price_twset_url?: string;
  }>({
    mst_4bundle_price_twset_latest_date: "",
    mst_4bundle_price_twset_url: "",
  });

  const fetchData = async () => {
    const payload = {
      ...(query.brand_cd.length > 0 ? { brand_cd: query.brand_cd } : {}),
      ...(query.item_cd.length > 0 ? { item_cd: query.item_cd } : {}),
      ...(query.honbu_flag !== undefined ? { honbu_flag: query.honbu_flag ? 1 : 0 } : {}),
      ...(query.store_flag !== undefined ? { store_flag: query.store_flag ? 1 : 0 } : {}),
      limit: query.limit,
      offset: query.offset,
    };
    setIsFetching(true);
    try {
      const prevScrollY =
        query.offset > 1 ? document.documentElement.scrollTop || document.body.scrollTop : 0;

      const { list, total } = await fetch4BundlePriceTwsetListApi(payload);
      setPrices(query.offset > 1 ? [...prices, ...list] : list);
      if (typeof total !== "number" || query.offset * query.limit >= total || list.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }

      if (query.offset > 1 && prevScrollY > 0) {
        window.scrollTo(0, prevScrollY);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsFetching(false);
    }
  };

  const onLoadMore = async () => {
    if (!hasMore) return;
    setQuery((prev) => ({ ...prev, offset: prev.offset + 1 }));
  };

  const updatePrice = async (price: PriceUpdatePayload) => {
    setIsFetching(true);
    store.dispatch(commonActions.setLoading());
    await update4BundlePriceTwsetApi(price);
    const data = await fetch4BundlePriceTwsetListApi({
      ...query,
      ...(query.honbu_flag !== undefined ? { honbu_flag: query.honbu_flag ? 1 : 0 } : {}),
      ...(query.store_flag !== undefined ? { store_flag: query.store_flag ? 1 : 0 } : {}),
      offset: 1
    });
    if (data.list.length > 0) {
      setPrices(data.list);
    }
    // if (response.status === 200) {
    //   Notify.setNotification({
    //     show: true,
    //     title: "更新が完了しました",
    //     confirmLabel: "OK",
    //     actionsPosition: "end",
    //   });
    // }
    setIsFetching(true);
    store.dispatch(commonActions.removeLoading());
  };

  const handleDownload = async () => {
    setIsFetching(true);
    const response = await getCsvDownloadApi();
    setCsvDownload({
      mst_4bundle_price_twset_latest_date: response?.mst_4bundle_price_twset_latest_date,
      mst_4bundle_price_twset_url: response?.mst_4bundle_price_twset_url,
    });
    setIsFetching(false);
  };

  useEffect(() => {
    fetchData();
  }, [query]);

  useEffect(() => {
    handleDownload();
  }, []);

  return {
    prices,
    setPrices,
    hasMore,
    setHasMore,
    isFetching,
    setIsFetching,
    query,
    setQuery,
    tempQuery,
    setTempQuery,
    fetchData,
    updatePrice,
    handleDownload,
    csvDownload,
    onLoadMore,
    loading: isFetching,
  };
};

export default use4BundlePriceTwset;
